// Picks and orders the character deck for the Story Review Reel.
// Ordering: practicing → new_introduction → reinforcement. Known/null excluded.
// Capped at 10 to keep the reel short. De-dupes by id so the same character
// can't appear twice when story_characters has multiple rows for one id.

const REEL_BUCKET_ORDER = ['practicing', 'new_introduction', 'reinforcement'];
const MAX_CARDS = 10;

export function selectReelCharacters(characters) {
  if (!Array.isArray(characters) || characters.length === 0) return [];

  const seen = new Set();
  const buckets = { practicing: [], new_introduction: [], reinforcement: [] };

  for (const c of characters) {
    if (!c || c.id == null) continue;
    if (!REEL_BUCKET_ORDER.includes(c.display_state)) continue;
    if (seen.has(c.id)) continue;
    seen.add(c.id);
    buckets[c.display_state].push(c);
  }

  const ordered = [];
  for (const key of REEL_BUCKET_ORDER) {
    for (const c of buckets[key]) {
      if (ordered.length >= MAX_CARDS) return ordered;
      ordered.push(c);
    }
  }
  return ordered;
}
